export var OCSPResponseStatus;
(function (OCSPResponseStatus) {
    OCSPResponseStatus[OCSPResponseStatus["successful"] = 0] = "successful";
    OCSPResponseStatus[OCSPResponseStatus["malformedRequest"] = 1] = "malformedRequest";
    OCSPResponseStatus[OCSPResponseStatus["internalError"] = 2] = "internalError";
    OCSPResponseStatus[OCSPResponseStatus["tryLater"] = 3] = "tryLater";
    OCSPResponseStatus[OCSPResponseStatus["sigRequired"] = 5] = "sigRequired";
    OCSPResponseStatus[OCSPResponseStatus["unauthorized"] = 6] = "unauthorized";
})(OCSPResponseStatus || (OCSPResponseStatus = {}));
